import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { DeleteBin } from "assets/icons";
import * as Component from "components";
import { Formik, Form } from "formik";
import * as Validation from "utils/Validation";
import { InputField } from "components/formfields";

const DeleteModal = ({
  isOpen,
  onClose,
  title,
  itemName = "Delete",
  onSubmit,
}) => {
  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          className="fixed inset-0 flex z-50 md:justify-center md:items-center bg-black dark:bg-[#1467B0B5] bg-opacity-50 justify-end items-end scroll-none"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.3 }}
          // onClick={onClose}
        >
          <motion.div
            className="py-5 w-full dark:bg-gray-950  bg-white rounded-t-3xl flex flex-col justify-center items-center gap-3 relative md:w-[450px] md:rounded-3xl"
            initial={{ y: "-100%" }}
            animate={{ y: "0%" }}
            exit={{ y: "-100%", opacity: 0 }}
            transition={{
              type: "just",
              stiffness: 300,
              damping: 20,
              duration: 0.3,
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="text-red-600">
              <DeleteBin size="size-16" />
            </div>
            <p className="text-[26px] dark:text-white text-[#170F49] font-bold text-center">
              {title}
            </p>
            <Formik
              initialValues={{ confirmation: "" }}
              validationSchema={Validation.DeleteProperty(itemName)}
              onSubmit={async (values, { setSubmitting }) => {
                await onSubmit();
                setSubmitting(false);
                onClose();
              }}
            >
              {({ isSubmitting, isValid }) => (
                <Form className="w-[80%]">
                  <InputField
                    type="text"
                    label={`To confirm, type "${itemName}" in the box below`}
                    placeholder={`Enter ${itemName}`}
                    name="confirmation"
                  />
                  <div className="flex justify-between gap-5 mt-4">
                    <button
                      type="button"
                      onClick={onClose}
                      className="w-full border rounded-md dark:text-white hover:bg-gray-100 dark:hover:bg-gray-500 text-black py-2"
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      disabled={isSubmitting || !isValid}
                      className={`w-full border ${
                        isSubmitting || !isValid
                          ? "bg-red-400 cursor-not-allowed"
                          : "bg-red-600 hover:bg-red-400"
                      } rounded-md text-white py-2 flex justify-center items-center cursor-pointer`}
                    >
                      {isSubmitting ? <Component.Spinner /> : "Delete"}
                    </button>
                  </div>
                </Form>
              )}
            </Formik>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default DeleteModal;
